const firebaseConfig = {
  apiKey: "AIzaSyCxJovuajLeQu2Wv5JI6wG5X1ri1BIrel8",
  authDomain: "power-techs.firebaseapp.com",
  projectId: "power-techs",
  storageBucket: "power-techs.appspot.com",
  messagingSenderId: "1031158060790",
  appId: "1:1031158060790:web:c93e01cca03807f323fed7"
};

export default firebaseConfig;